module.exports = { tournamentList: [] }
